<template>
  <div>
    <b-card>
      <h4 class="card-title">{{ $t('pages.settings.subscription.title') }}</h4>
      <p class="card-title-desc">{{ $t('pages.settings.subscription.subtitle') }}</p>

      <b-card-body>
        <b-row style="min-height: 25em;">
          <loader :loading="loading">
            <b-col sm="12" v-if="subscriptionDetails">
              <div>
                <h6>{{ $t('pages.settings.subscription.plan').toUpperCase() }}</h6>
                <hr class="m-0 mb-2">
                <div class="row">
                  <div class="col-sm-6">
                    <div>
                      <p class="text-muted mb-1">
                        {{ $t('common.pricing.' + subscriptionDetails.plan_name) }}
                        <f-badge :variant="subscriptionDetails.active ? 'success' : 'danger'">
                          {{
                            $t('pages.settings.subscription.status.' + subscriptionDetails.status)
                          }}
                        </f-badge>
                      </p>
                      <p class="text-muted mb-1">${{
                          subscriptionDetails.price
                        }}/{{ $t('pages.settings.subscription.month') }}
                      </p>
                      <div class="mb-1" v-if="subscriptionDetails.cancelled_at && subscriptionDetails.active">
                        <p class="text-muted">
                          {{ $t('pages.settings.subscription.cancelled_at') }} : {{subscriptionDetails.cancelled_at | date('MMMM d, YYYY')}}
                        </p>
                        <a href="javascript: void(0);" @click="resumeSubscription()">
                          {{ $t('pages.settings.subscription.resume_subscription') }}
                        </a>
                      </div>

                      <p class="text-muted mb-1" v-if="subscriptionDetails.is_trial">
                        {{ $t('pages.settings.subscription.remain_days', {days: subscriptionDetails.days_remain >= 0 ? subscriptionDetails.days_remain : 0}) }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="text-sm-end mt-4 mt-sm-0">
                      <b-btn size="sm" variant="success" @click="$router.push({name:'pricing'})">
                        <i class="mdi mdi-credit-card"></i>
                        {{ $t('pages.settings.subscription.change_plan') }}
                      </b-btn>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <h6>{{ $t('pages.settings.subscription.last_billing') }}</h6>
                <hr class="m-0 mb-2">
                <div class="row">
                  <div class="col-sm-6">
                    <div v-if="subscriptionDetails">
                      <p class="text-muted mb-1"> {{ subscriptionDetails.current_period_start | unixDate }} </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div v-if="subscriptionDetails" class="text-sm-end mt-4 mt-sm-0 d-grid">
                      <a href="javascript: void(0);" @click="download(subscriptionDetails.invoice)"
                         :class="{'disabled': !subscriptionDetails.invoice}">
                        <b-spinner v-if="invoiceLoading" small class="mx-1"></b-spinner>
                        <i v-else class="mdi mdi-receipt"></i>
                        {{ $t('pages.settings.subscription.download_invoice') }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>


              <div class="mt-4">
                <h6>{{ $t('pages.settings.subscription.next_billing') }}</h6>
                <hr class="m-0 mb-2">
                <div class="row">
                  <div class="col-sm-6">
                    <div v-if="subscriptionDetails">
                      <p class="text-muted mb-1"> {{ subscriptionDetails.current_period_end | unixDate }} </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="text-sm-end mt-4 mt-sm-0 d-grid">
                      <a href="javascript: void(0);" @click="cancelSubscription"
                         :class="{'disabled': !subscriptionDetails.active || subscriptionDetails.plan_name === 'free_plan' || subscriptionDetails.cancelled_at}">
                        {{ $t('pages.settings.subscription.cancel_subscription') }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <h6>{{ $t('pages.settings.subscription.billing_portal') }}</h6>
                <hr class="m-0 mb-2">
                <div class="row">
                  <div class="col-sm-6">
                    <p class="text-muted mb-1">  {{ $t('pages.settings.subscription.billing_portal_info') }} </p>
                  </div>
                  <div class="col-sm-6 text-end">
                    <a href="javascript: void(0);" @click="redirectBillingPortal"
                       :class="{'disabled': !subscriptionDetails.invoice}">
                      {{ $t('pages.settings.subscription.open_billing_portal') }}
                    </a>
                  </div>
                </div>
              </div>
            </b-col>
          </loader>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

import UserService from "../../../Services/Api/UserService";
import SubscriptionService from "../../../Services/Api/SubscriptionService";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      subscriptionDetails: null,
      loading: false,
      invoiceLoading: false
    }
  },

  mounted() {
    this.loading = true
    SubscriptionService.getSubscriptionDetails().then((details) => {
      this.subscriptionDetails = details.data
    }).finally(() => {
      this.loading = false
    })
  },

  methods: {
    async getDetails() {
      SubscriptionService.getSubscriptionDetails().then(res => {
        this.subscriptionDetails = res.data
      })
    },
    async resumeSubscription() {
      await UserService.resumeSubscription().then(() => {
        this.getDetails()
      })
    },
    async cancelSubscription() {
      Swal.fire({
        title: this.$t('pages.settings.subscription.cancel_info'),
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t('pages.settings.subscription.continue')
      }).then(async (result) => {
        if (result.value) {
          await UserService.cancelSubscription().then(() => {
            this.getDetails()
          })
        }
      });
    },
    download(url) {
      this.invoiceLoading = true
      const downloadWindow = window.open(url, '_blank')
      const loading = setInterval(() => {
        if (downloadWindow.closed) {
          clearInterval(loading)
          this.invoiceLoading = false
        }
      }, 500)
    },
    async redirectBillingPortal() {
      await UserService.billingPortal({}).then((res) => {
        window.open(res.data.url, '_blank')
      })
    }
  }
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.65;
}
</style>